import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { handlePostRequest } from '../../utils/api-handler.util'
import { showToaster } from '../../utils/show-toaster.util'
import { OTP_PURPOSE_FORGOT_PASSWORD } from '../../constants/otp'
import { validatePhoneNumber } from '../../constants/validation'
import BackIcon from '../../components/icons/BackIcon'
import { useHistory } from '../../contexts/HistoryContext'
import PhoneInput from '../../components/common/PhoneInput'

export default function ForgotPasswordInitiate() {
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { goBackOrHome } = useHistory()
  const [formData, setFormData] = useState({
    phoneNumber: '',
    password: '',
  })

  const initiateForgotPasswordMutation = useMutation({
    mutationFn: (data) => handlePostRequest('/forgot-password', data),
    onSuccess: () => {
      showToaster('success', 'OTP sent successfully!')
      navigate('/forgot-password/verify-otp', { state: { phoneNumber: formData.phoneNumber } })
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || 'Failed to send OTP'
      setError(errorMessage)
    },
  })

  const handleInitiate = (e) => {
    e.preventDefault()
    setError('')

    const validationError = validatePhoneNumber(formData.phoneNumber)
    if (validationError) {
      setError(validationError)
      return
    }

    initiateForgotPasswordMutation.mutate({
      phoneNumber: formData.phoneNumber,
      purpose: OTP_PURPOSE_FORGOT_PASSWORD,
    })
  }

  return (
    <div className="w-full max-w-md mx-auto bg-background shadow-lg min-h-screen rounded-xl overflow-hidden">
      <div className="flex items-center p-4">
        <button
          className="flex items-center justify-center bg-background border border-gray-200 rounded-full w-10 h-10 shadow-sm hover:bg-neutral-200-50 transition-colors duration-200"
          onClick={() => goBackOrHome()}
          aria-label="Back"
        >
          <BackIcon />
        </button>
      </div>

      <div className="flex justify-center py-8">
        <img src="/eastsoko-logo.png" alt="Sokooni Logo" className="w-36  object-contain" />
      </div>

      <div className="px-6 pb-8">
        <h1 className="text-2xl font-bold text-foreground text-center font-inter mb-2">
          Forgot Password
        </h1>
        <p className="text-sm font-medium text-medium-opacity text-center font-inter mb-8">
          Enter your phone number to receive a reset code
        </p>

        <form onSubmit={handleInitiate} className="space-y-6">
          <PhoneInput
            id="phoneNumber"
            label="Enter your phone number"
            value={formData.phoneNumber}
            onChange={(phone) => setFormData({ ...formData, phoneNumber: phone })}
            required
          />

          {error && <div className="text-error-900 text-sm font-medium text-center">{error}</div>}

          <button
            type="submit"
            className="w-full py-3 bg-gradient-to-r from-secondary-700 to-secondary-500 text-white text-lg font-medium font-inter rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 disabled:opacity-70"
            disabled={initiateForgotPasswordMutation.isPending}
          >
            {initiateForgotPasswordMutation.isPending ? 'Sending...' : 'Send OTP'}
          </button>
        </form>
      </div>
    </div>
  )
}
